import script from "./AnnualExpense.vue?vue&type=script&setup=true&lang=ts"
export * from "./AnnualExpense.vue?vue&type=script&setup=true&lang=ts"

import "./AnnualExpense.vue?vue&type=style&index=0&id=d047c176&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d047c176"]])

export default __exports__